import { useQuery } from 'hooks/reactQuery';

import { getCmModuleAvailableVendors } from '@api/cmModuleCommon';

import { mapDropdownOptions } from '@utils/formatter';

import { EUserRoles, TVendorsLabels, TVendorsValues } from '@enums/common';

import { CM_MODULE_VENDORS } from '@constants/queryKeys';

export interface IUseQueryCmModuleVendorsReturnType {
	cmModuleVendorOptions: Array<{
		value: TVendorsValues;
		label: TVendorsLabels;
		isDefault: boolean;
	}>;
	isLoadingCmModuleVendors: boolean;
}

export const useQueryCmModuleVendors = (): IUseQueryCmModuleVendorsReturnType => {
	const {
		data,
		isInitialLoading,
	} = useQuery({
		queryFn: getCmModuleAvailableVendors,
		queryKey: [CM_MODULE_VENDORS],
		select: (data) => mapDropdownOptions({
			items: data,
			labelKey: 'vendor.title',
			valueKey: 'vendor.name',
			additionalMappings: {
				isDefault: 'isFavourite',
			},
		}).map(option => ({
			value: option.value as TVendorsValues,
			label: option.label as TVendorsLabels,
			isDefault: JSON.parse(option.isDefault),
		})),
		allowedRoles: [
			EUserRoles.networkOperatorOrganizationAdministrator,
			EUserRoles.networkOperatorAssetEnquirer,
			EUserRoles.networkOperatorAssetViewer,
			EUserRoles.networkOperatorTelecomSitesViewer,
			EUserRoles.networkOperatorTelecomSitesAttributeUpdater,
			EUserRoles.networkOperatorKpiViewer,
			EUserRoles.networkOperatorThresholdKpiViewer,
			EUserRoles.networkOperatorKpiUpdater,
			EUserRoles.networkOperatorThresholdKpiUpdater,
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleViewer,
			EUserRoles.networkOperatorCmModuleUpdater,
			EUserRoles.networkOperatorCmModuleAdmin,
			EUserRoles.networkOperatorAlarmManager,
			EUserRoles.smoLightViewer,
			EUserRoles.smoLightUpdater,
		],
	});

	return {
		cmModuleVendorOptions: data || [],
		isLoadingCmModuleVendors: isInitialLoading,
	};
};
